// SEO 规范函数
export const formatURLStandard = (text?: string, limit = 6) => {
  return text
    ?.replace(/[^a-zA-Z0-9\s\u00C0-\u024F\u4E00-\u9FFF]/g, '')
    ?.split(' ')
    ?.filter((v) => v)
    ?.slice(0, limit)
    ?.join('-')
    ?.toLowerCase();
};

export const formatProductLink = (
  skuId: string,
  skuName?: string,
  inner: boolean = true,
  limit = 6,
) => {
  return skuName ? `/dp/${formatURLStandard(skuName, limit)}/${skuId}` : `/dp/${skuId}`;
};
